export default __webpack_public_path__ + "static/media/down.e5284d57.svg";